import { HighlightConfig } from '../../infra';

export const HIGHTLIGHT_CONFIG: HighlightConfig = {
    projectId: 'ldwyv5go',
};
